import type { App, NetworkId } from "@alch/dx-entities";
import { trpc } from "@util/trpc/trpcClient";

export const useUpdateAppNetworkAllowlist = ({
  scopeId,
}: {
  scopeId?: string;
} = {}) => {
  const utils = trpc.useUtils();

  return trpc.apps.updateAppNetworkAllowlist.useMutation({
    scope: scopeId ? { id: scopeId } : undefined,
    onMutate: async ({ appId, networkIds }) => {
      const apps = utils.apps.getApps.getData();
      const app = apps?.find((app) => app.sid === appId);

      if (!app) {
        return;
      }

      const networkAllowlist = app.networkAllowlist as string[];

      const networksToAdd = networkIds.filter(
        (id) => !networkAllowlist?.includes(id),
      );
      const networksToRemove = networkAllowlist?.filter(
        (id) => !networkIds.includes(id),
      );

      utils.apps.getApps.setData(undefined, (apps) =>
        updateAppNetworkAllowlistInCache({
          apps,
          appId,
          networksToAdd,
          networksToRemove,
        }),
      );

      return { networksToAdd, networksToRemove };
    },
    onError: (_error, { appId }, context) => {
      if (!context) {
        return;
      }

      utils.apps.getApps.setData(undefined, (apps) =>
        updateAppNetworkAllowlistInCache({
          apps,
          appId,
          networksToAdd: context.networksToRemove,
          networksToRemove: context.networksToAdd,
        }),
      );
    },
  });
};

const updateAppNetworkAllowlistInCache = ({
  apps,
  appId,
  networksToAdd,
  networksToRemove,
}: {
  apps: App[] | undefined;
  appId: string;
  networksToAdd: string[];
  networksToRemove: string[];
}) => {
  return apps?.map((app) => {
    if (app.sid !== appId) {
      return app;
    }

    return {
      ...app,
      networkAllowlist: [
        ...app.networkAllowlist.filter((id) => !networksToRemove.includes(id)),
        ...networksToAdd,
      ] as NetworkId[],
    };
  });
};
